// @flow
import React from 'react';
import { useFormikContext } from 'formik';

import { PaddedAndRaisedSegment } from '../presentational/PaddedAndRaisedSegment';
import { Spacer } from '../presentational/spacing/Spacer';
import { isAnythingEditedOnEstimatePageBesidesTheGivenForm } from '../views/utils';
import {
  ESTIMATE_CUSTOM_DISCOUNTS_DETAILS_FORM,
  IS_RENEWAL_AUTOMATION_LIVE,
} from '../../constants';
import { RenewalDiscountValidationWarningContainer } from '../renewal-automation/RenewalDiscountValidationWarningContainer';
import { RenewalPolicyMessageContainer } from '../renewal-automation/RenewalPolicyMessageContainer';
import { If } from '../presentational/If';

import { MetricsLevelDiscountsTopLevelContainer } from './metrics-level-configuration/MetricsLevelDiscountsTopLevelContainer';
import { GlobalDiscountContainer } from './global-discount/GlobalDiscountContainer';

export const CustomDiscountsTopLevelContainer = ({ readOnlyMode }) => {
  const { values, initialValues } = useFormikContext();

  const disabled = isAnythingEditedOnEstimatePageBesidesTheGivenForm(
    values,
    initialValues,
    ESTIMATE_CUSTOM_DISCOUNTS_DETAILS_FORM
  );

  return (
    <PaddedAndRaisedSegment disabled={disabled}>
      <If test={IS_RENEWAL_AUTOMATION_LIVE}>
        <RenewalDiscountValidationWarningContainer />
        <Spacer y={10} />
      </If>
      <If test={!IS_RENEWAL_AUTOMATION_LIVE}>
        <RenewalPolicyMessageContainer />
      </If>
      <GlobalDiscountContainer readOnlyMode={readOnlyMode} />
      <MetricsLevelDiscountsTopLevelContainer readOnlyMode={readOnlyMode} />
    </PaddedAndRaisedSegment>
  );
};

// todo::Remove RO Mode completely and just call it disabled everywhere...
